(() => {
  if (customElements.get('wohnjoy-empty-cart-products')) return;
  class WohnjoyEmptyCartProducts extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.controller = new AbortController();
      this.drawer = this.closest('cart-notification, cart-drawer');
      this.observer = new IntersectionObserver(entries => {
        if (!this.drawerVisible() || this.loading || !entries.some(entry => entry.isIntersecting)) return;
        this.loading = true;
        this.observer.disconnect();
        this.drawerObserver?.disconnect();
        this.load().catch(() => {});
      }, { rootMargin: '300px' });
      if (this.drawer) {
        this.drawerObserver = new MutationObserver(() => this.observeWhenVisible());
        this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class', 'open'] });
      }
      this.observeWhenVisible();
    }
    drawerVisible() {
      return !this.drawer || this.drawer.classList.contains('open') || this.drawer.classList.contains('active') || this.drawer.hasAttribute('open');
    }
    observeWhenVisible() {
      if (this.loading) return;
      if (this.drawerVisible()) this.observer.observe(this);
      else this.observer.unobserve(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.drawerObserver?.disconnect();
      this.controller?.abort();
      this.started = false;
      this.loading = false;
    }
    async load() {
      const controller = this.controller;
      const config = JSON.parse(this.querySelector('[data-wj-cart-room-config]').textContent);
      const content = this.querySelector('[data-wj-empty-content]');
      const products = this.querySelector('[data-wj-empty-products]');
      products.replaceChildren();
      const selection = new window.WohnjoyRoomSelection(controller.signal, 'wohnjoy-empty-cart-candidates');
      await selection.collect(config, card => {
        if (controller.signal.aborted || !this.isConnected) return;
        products.append(document.importNode(card.content, true));
        content.hidden = false;
      });
    }
  }
  customElements.define('wohnjoy-empty-cart-products', WohnjoyEmptyCartProducts);
})();
